import { render, staticRenderFns } from "./SystemTeamAllocation.vue?vue&type=template&id=8b89459a"
import script from "./SystemTeamAllocation.vue?vue&type=script&lang=js"
export * from "./SystemTeamAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports